import{jsx as o}from"react/jsx-runtime";import{TranslationsProvider as r}from"./components/TranslationsProvider/TranslationsProvider.js";const e=e=>n=>o(r,{languageCode:n.languageCode,children:o(e,{...n})});export{e as withTranslations};
//# sourceMappingURL=withTranslations.js.map
